import { Paragraph } from "../../../../src/common/Markdown";
import * as React from 'react';
export default {
  Paragraph,
  React
};